/*
 *  I01EVACONSSYSTECS2Calcul.js
 *
 *  Created by Sébastien Hecart on 2017-12-09 11:48:53 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

import { fetchCoefficientMajorationBatiment, fetchDebitPlomberie } from '@batical/data/src'
import i18n from '@batical/i18n'
import { RDebitPlomberieSchema_Type, RCoefficientMajorationBatiment_Type, I01EVACONSSYSTECS2_State } from '@batical/types/src'

import { puissanceThermiqueECS } from '../CommonFormula'

function I01EVACONSSYSTECS2_docalcul(state: I01EVACONSSYSTECS2_State) {
  let selectedcoeffMajoration_uuid: RCoefficientMajorationBatiment_Type = fetchCoefficientMajorationBatiment(state.coeffMajoration_uuid)
  // if let coefMaj = coefficientMajorationSelected(){
  //     let state.in_tempFroide = state.in_tempFroide
  //     let tempreatureBouclage = state.in_tempChaude
  const tempDiff = state.in_tempChaude - state.in_tempFroide
  let out_totalLogementStandard = 0.0
  let coeffStockageECS: number = 0

  out_totalLogementStandard += calculPlomberie('1', state.in_tempFroide, state.in_tempChaude, state.in_evier)
  out_totalLogementStandard += calculPlomberie('2', state.in_tempFroide, state.in_tempChaude, state.in_lavabo)
  out_totalLogementStandard += calculPlomberie('3', state.in_tempFroide, state.in_tempChaude, state.in_bidet)
  out_totalLogementStandard += calculPlomberie('4', state.in_tempFroide, state.in_tempChaude, state.in_baignoire)
  out_totalLogementStandard += calculPlomberie('5', state.in_tempFroide, state.in_tempChaude, state.in_douche)
  out_totalLogementStandard += calculPlomberie('6', state.in_tempFroide, state.in_tempChaude, state.in_robinetdemi)
  out_totalLogementStandard += calculPlomberie('7', state.in_tempFroide, state.in_tempChaude, state.in_robinetquart)
  out_totalLogementStandard += calculPlomberie('8', state.in_tempFroide, state.in_tempChaude, state.in_lavemain)
  out_totalLogementStandard += calculPlomberie('9', state.in_tempFroide, state.in_tempChaude, state.in_baclaver)
  out_totalLogementStandard += calculPlomberie('10', state.in_tempFroide, state.in_tempChaude, state.in_linge)
  out_totalLogementStandard += calculPlomberie('11', state.in_tempFroide, state.in_tempChaude, state.in_vaiselle)
  const res_debit = 60.0 * out_totalLogementStandard
  if (out_totalLogementStandard > 0) {
    let sum =
      state.in_evier +
      state.in_lavabo +
      state.in_bidet +
      state.in_baignoire +
      state.in_douche +
      state.in_robinetdemi +
      state.in_robinetquart +
      state.in_lavemain +
      state.in_baclaver +
      state.in_linge +
      state.in_vaiselle
    state.res_S = (selectedcoeffMajoration_uuid.coeffMajoration * 0.8) / Math.sqrt(sum - 1)
    state.res_debitMinute = state.res_S * res_debit
    state.res_debit10mn = state.res_debitMinute * 10
    state.res_debitSeconde = state.res_debitMinute / 60
    state.res_consommationJournaliere = state.in_content * state.in_nombreElementPickerData

    //type couplage ECS
    //I01EVACONSSYSTECS2_couple_inst : 'Couple Instantanée',
    //I01EVACONSSYSTECS2_couple_semi : 'Couple Semi-instantané',
    //I01EVACONSSYSTECS2_couple_semiacc

    if (state.in_typeCalcul === 0) {
      coeffStockageECS = tempDiff / (state.in_departPrimaire - state.in_tempFroide)
    } else {
      coeffStockageECS = tempDiff / (state.in_departPrimaire - state.in_retourPrimaire)
    }
    const var_simultaneiteStandard = state.in_pourcentLpointe / state.in_dureeHPointe
    const var_simulRetenu = Math.max(state.res_S, var_simultaneiteStandard)
    var maxiSemiInstant =
      (state.res_consommationJournaliere - 6 * (1 / var_simulRetenu + state.in_tempsEntrePointe) * state.res_debit10mn) /
      (1 - 6 * (1 / var_simulRetenu + state.in_tempsEntrePointe))
    if (state.in_typeCalcul === 1) {
      maxiSemiInstant = maxiSemiInstant * coeffStockageECS
    }

    state.res_maxVolumeTypeECS =
      Math.round(
        ((state.res_consommationJournaliere * var_simulRetenu * (state.in_dureeHPointe + state.in_tempsEntrePointe)) /
          (var_simulRetenu * (state.in_dureeHPointe + state.in_tempsEntrePointe) + 1)) *
          coeffStockageECS *
          100
      ) / 100
    if (state.in_volumeTypeECS === 0) {
      state.res_modeCoupleECS = i18n.t('I01EVACONSSYSTECS2_couple_inst')
      //=(affichage!C32*3600*(affichage!C35-affichage!C34)*1,163/1000)
      state.res_puissanceTypeECS = (state.res_debitSeconde * 3600 * tempDiff * 1.163) / 1000
    } else if (state.in_volumeTypeECS < maxiSemiInstant) {
      //=B29*(affichage!C30-affichage!C41)*(affichage!C35-affichage!C34)*1,163*10^(-3)/(1/6)/0,9
      state.res_modeCoupleECS = i18n.t('I01EVACONSSYSTECS2_couple_semi')
      state.res_puissanceTypeECS =
        (((coeffStockageECS * (state.res_debit10mn - state.in_volumeTypeECS) * tempDiff * 1.163) / 1000) * 6) / 0.9
      if (state.in_typeCalcul === 1) {
        state.res_puissanceTypeECS =
          ((((state.res_debit10mn - state.in_volumeTypeECS / coeffStockageECS) * tempDiff * 1.163) / 1000) * 6) / 0.9
      }
    } else {
      //=B29*(affichage!C35-affichage!C34)*1,163*10^(-3)*((C19-affichage!C41)/(E14+E15))/0,9
      state.res_modeCoupleECS = i18n.t('I01EVACONSSYSTECS2_couple_semiacc')
      state.res_puissanceTypeECS =
        ((coeffStockageECS * tempDiff * 1.163) / 1000) *
        ((state.res_consommationJournaliere - state.in_volumeTypeECS) / (1 / var_simulRetenu + state.in_tempsEntrePointe) / 0.9)
      if (state.in_typeCalcul === 1) {
        state.res_puissanceTypeECS =
          (((tempDiff * 1.163) / 1000 / 0.9) * (state.res_consommationJournaliere - state.in_volumeTypeECS / coeffStockageECS)) /
          (1 / var_simulRetenu + state.in_tempsEntrePointe)
      }
    }
    //=(C38+affichage!C44*0,1)*(C35-C34)*1,163/C45/1000
  }
  if (state.in_typeCalcul === 1) {
    state.res_puissanceNecessaire = puissanceThermiqueECS(state.res_debit10mn, state.in_tempChaude, state.in_tempFroide)
  }
  state.invalidated = false
  return state
}

function calculPlomberie(type: string, tempEauFroideArrive: number, tempBouclage: number, quantite: number): number {
  let debs: RDebitPlomberieSchema_Type = fetchDebitPlomberie(type)
  return (quantite * debs.debit * (debs.temperature - tempEauFroideArrive)) / (tempBouclage - tempEauFroideArrive)
}

export default I01EVACONSSYSTECS2_docalcul
